module.exports = __webpack_public_path__ + "static/img/sello_pime.b4f8e6b1.png";